module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"nextButtonLabel":"Next","publishButtonLabel":"Publish","actionsButtonLabel":"Actions","saveAsTemplateAction":"Save as a template"}}')
  delete Component.options._Ctor
}
